import { footerLinks } from '@/mocks/home';

export default function Footer() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-secondary-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
          <div className="col-span-2 md:col-span-1">
            <a
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                handleClick('#hero');
              }}
              className="inline-flex items-center gap-2 whitespace-nowrap cursor-pointer"
            >
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-fill text-background-50 text-lg"></i>
              </span>
              <span className="text-xl font-bold text-foreground-900 tracking-tight">
                豆花视频
              </span>
            </a>
            <p className="mt-3 text-sm text-foreground-500 leading-relaxed">
              高清免费影视聚合平台，聚合91视频、97视频、51视频优质内容。
              全站免费无广告，每日更新，让每一位观众享受纯粹的观影体验。
            </p>
          </div>

          {footerLinks.map((group, gi) => (
            <div key={gi}>
              <h4 className="text-sm font-bold text-foreground-900 mb-3">
                {group.group}
              </h4>
              <ul className="flex flex-col gap-2">
                {group.links.map((link, li) => (
                  <li key={li}>
                    <a
                      href={link.href}
                      onClick={(e) => {
                        e.preventDefault();
                        handleClick(link.href);
                      }}
                      className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 md:mt-12 pt-6 md:pt-8 border-t border-secondary-200/60">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex flex-wrap items-center justify-center gap-4 text-xs text-foreground-400">
              <span>合作伙伴</span>
            </div>
            <p className="text-xs text-foreground-400">
              &copy; {new Date().getFullYear()} 豆花视频 - 高清免费影视聚合平台
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}